import React from 'react';
import { Alert, Button, Box, Typography } from '@mui/material';

/**
 * React 19: Error Boundary Komponente
 * Fängt JavaScript-Fehler in Child-Komponenten ab und zeigt eine Fallback-UI.
 * Wird zusammen mit Suspense für robustes Error-Handling verwendet.
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // State aktualisieren, damit beim nächsten Render die Fallback-UI angezeigt wird
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Fehler loggen
        console.error('ErrorBoundary caught an error:', error, errorInfo);
        this.setState({ errorInfo });
    }

    handleRetry = () => {
        this.setState({ hasError: false, error: null, errorInfo: null });
    };

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            // Custom Fallback wenn vorhanden
            if (this.props.fallback) {
                return this.props.fallback;
            }

            // Standard Fallback UI
            return (
                <Box sx={{
                    p: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '200px'
                }}>
                    <Alert
                        severity="error"
                        sx={{ mb: 2, maxWidth: '600px' }}
                    >
                        <Typography variant="h6" component="div" gutterBottom>
                            Ein Fehler ist aufgetreten
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {this.state.error?.message || 'Unbekannter Fehler'}
                        </Typography>
                    </Alert>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Button
                            variant="outlined"
                            onClick={this.handleRetry}
                        >
                            Erneut versuchen
                        </Button>
                        <Button
                            variant="contained"
                            onClick={this.handleReload}
                        >
                            Seite neu laden
                        </Button>
                    </Box>
                </Box>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
